import { getUrlForNotification } from "layouts/Sidenav/AccountInfo/Notification/NotificationItem";
import { isEqual, omit } from "lodash";
import moment from "moment";

export const flattenObject = (inputObj: { [key: string]: any }) => {
  const outputObj: { [key: string]: string } = {};

  for (const i in inputObj) {
    if (!inputObj.hasOwnProperty(i)) continue;

    if (typeof inputObj[i] === "object") {
      const flatObject = flattenObject(inputObj[i]);
      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        outputObj[i + "." + x] = flatObject[x];
      }
    } else {
      outputObj[i] = inputObj[i];
    }
  }
  return outputObj;
};

export const formatMMDDYYYToDDMMYYYY = (s: string) => {
  if (!s) return null;
  var b = s.split(/\D/);
  return [b[1], b[0], b[2]].join("/");
};
export const formatDDMMYYYYToMMDDYYYY = (date: string) => {
  if (!date) return null;
  const a = date.split("/");
  return [a[1], a[0], a[2]].join("/");
};

export const validateToDateFlashDeal = (fromDate: Date, toDate: Date) => {
  const fromDateTime = moment(fromDate).valueOf();
  const toDateTime = moment(toDate).valueOf();
  const mathDate = Math.floor((toDateTime - fromDateTime) / (24 * 3600 * 1000));
  return mathDate;
};
export const formatFromDate = (date: Date) => {
  if (!date) return null;
  const from = new Date(date);
  from.setHours(0, 0, 0);
  return from;
};

export const formatToDate = (date: Date) => {
  if (!date) return null;
  const to = new Date(date);
  to.setHours(23, 59, 59);
  return to;
};

export const latestNotifyPeriod = (arr, prop) => {
  var max;
  for (var i = 0; i < arr.length; i++) {
    if (!max || parseInt(arr[i][prop]) > parseInt(max[prop])) max = arr[i];
  }
  return max;
};

export const formatDateToISOString = (type: string, date: Date) => {
  // 2 loại type: from/to

  if (type === "from") {
    const dateSplit = date.toString().split("+")[0];
    const returnDate = new Date(dateSplit);
    returnDate.setHours(0, 0, 0);
    return returnDate.toISOString();
  } else {
    const dateSplit = date.toString().split("+")[0];
    const returnDate = new Date(dateSplit);
    returnDate.setHours(23, 59, 59);
    return returnDate.toISOString();
  }
};

export const getTimeAgo = (date: string): string => {
  const past = new Date(date);
  const now = new Date();
  const secondsPast = Math.floor((now.getTime() - past.getTime()) / 1000);

  if (secondsPast < 60) {
    return "Vừa xong";
  }

  const minutesPast = Math.floor(secondsPast / 60);
  if (minutesPast < 60) {
    return minutesPast === 1 ? "1 phút trước" : `${minutesPast} phút trước`;
  }

  const hoursPast = Math.floor(minutesPast / 60);
  if (hoursPast < 24) {
    return hoursPast === 1 ? "1 giờ trước" : `${hoursPast} giờ trước`;
  }

  const daysPast = Math.floor(hoursPast / 24);
  return daysPast === 1 ? "1 ngày trước" : `${daysPast} ngày trước`;
};

export const getTimeFromDateString = (dateString: string): string => {
  return moment(dateString).format("HH:mm");
};

export const formatDateStringToDDMMYYYY = (dateString: string) => {
  return moment(dateString).format("DD/MM/YYYY");
};

export const getChangedProperties = (
  oldObj: any,
  newObj: any,
  keyRemove?: Array<string>
) => {
  const changes = {};

  const isObject = (obj: any) =>
    obj && typeof obj === "object" && !Array.isArray(obj);
  const compare = (oldItem: any, newItem: any, changes) => {
    Object.keys(newItem).forEach((key) => {
      if (key === "undefined" || (keyRemove ?? []).some((i) => key.includes(i)))
        return;

      const oldValue = oldItem[key];
      const newValue = newItem[key];
      if (Array.isArray(oldValue) || Array.isArray(newValue)) {
        if (Array.isArray(newValue)) {
          const arrayChanges = getChangesOfArray(oldValue, newValue, keyRemove);

          if (arrayChanges.length > 0) {
            changes[key] = arrayChanges;
          }
        } else if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
          changes[key] = newValue;
        }
      } else if (isObject(oldValue) && isObject(newValue)) {
        const nestedChanges = getChangedProperties(
          oldValue,
          newValue,
          keyRemove
        );
        if (Object.keys(nestedChanges).length > 0) {
          changes[key] = nestedChanges;
        }
      } else if (oldValue !== newValue) {
        changes[key] = newValue;
      }
    });
  };

  compare(oldObj, newObj, changes);
  return changes;
};

export const formatChangeValid = (change: Object) => {
  Object.keys(change).forEach((key) => {
    if (Array.isArray(change[key])) {
      change[key] = change[key].filter(
        (item) => !(item.files ?? []).some((file) => file.lastModified)
      );
    }
  });
};

type Item = {
  id?: number | string;
  [key: string]: any;
};

type Change = {
  id?: number | string;
  editType?: string;
  [key: string]: any;
};

export const getChangesOfArray = (
  oldArray: Item[],
  newArray: Item[],
  keyRemove?: Array<string>
): Change[] => {
  const changes: Change[] = [];
  const oldMap = new Map<number | string, Item>();

  (oldArray ?? []).forEach((item) => {
    if (item.id !== undefined) {
      oldMap.set(item.id, item);
    }
  });

  (newArray ?? []).forEach((newItem) => {
    if (newItem?.id) {
      const oldItem = oldMap.get(newItem?.id);
      if (oldItem) {
        const change: Change = { id: newItem?.id, editType: "UPDATE" };
        let hasChange = false;
        Object.keys(newItem).forEach((key) => {
          if (
            key === "undefined" ||
            (keyRemove ?? []).some((i) => key.includes(i))
          ) {
            return;
          } else if (key !== "id" && !isEqual(oldItem[key], newItem[key])) {
            change[key] = newItem[key];
            hasChange = true;
          }
        });
        if (hasChange) {
          changes.push(change);
        }
        oldMap.delete(newItem?.id);
      }
    } else {
      const item = omit(newItem, keyRemove);
      changes.push({ ...item, editType: "ADDNEW" });
    }
  });

  oldMap.forEach((_, id) => {
    if (id) {
      changes.push({ id, editType: "DELETE" });
    }
  });

  return changes;
};

export const filterEmptyProperties = (obj: any) => {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    if (
      (Array.isArray(value) && value.length > 0) ||
      (typeof value === "object" &&
        value !== null &&
        Object.keys(value).length > 0) ||
      (typeof value !== "object" && value !== undefined && value !== null)
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const formatCurrencyVND = (amount: number): string => {
  return amount && amount > 0
    ? new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
        minimumFractionDigits: 0,
      })
        .format(amount)
        .replace("₫", "VNĐ")
    : "---";
};

export const isDateFormat = (dateString: any) => {
  if (!dateString || typeof dateString !== "string") return false;
  // Regular expression to match DD/MM/YYYY format
  const pattern = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  return pattern.test(dateString);
};

export const transformDate = (date) => {
  return date instanceof moment
    ? moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    : date;
};

export const getFileExtension = (fileName: string) => {
  return (fileName ?? "").split(".").pop().toLowerCase();
};

export const exportFileExcel = (data: any, fileName: string) => {
  const blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  // Clean up
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const showNotification = (payload) => {
  const notification = new Notification(payload.title, {
    body: payload.body,
  });

  notification.onclick = (event) => {
    event.preventDefault();
    window.focus();
    const { url } = getUrlForNotification(
      payload.noticeType,
      payload.readStatus,
      payload.manager,
      payload.objectId ?? ""
    );
    window.location.href = `${url}/${payload.objectId ?? ""}`;
  };
};

export const decodeHtml = (html: string) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};
